import { useContext, useEffect, useState } from "react";
import { InvoiceContext } from "../InvoiceProvider";
import { billingMicroserviceUrl } from "../../../../../microservices/billing_microservice";
import { AppContext } from "../../../../AppProvider";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Invoices/Invoice/InvoiceDetails.css";
import DatePicker from "react-datepicker";
import ToogleButton from "../../../../controls/ToogleButton";
import {v4 as uuidv4} from 'uuid';
import { useNavigate } from "react-router-dom";

const InvoiceDetails = ({selectedInvoiceTab}) =>{
    const {user,logout} = useContext(AppContext);
    const {selectedInvoice,setSelectedInvoice,setReloadInvoices,setSelectedInvoiceSummary} = useContext(InvoiceContext);
    const navigate = useNavigate();
    const [invoiceEditMode,setInvoiceEditMode] = useState(false);
    const [selectedInvoiceDetailsTab,setSelectedInvoiceDetailsTab] = useState('default');
    const [customerAccountFilterString,setCustomerAccountFilterString] = useState('');
    const [showCustomerAccountBrowser,setShowCustomerAccountBrowser] = useState(false);
    const [durationTypeFilterString,setDurationTypeFilterString] = useState('');
    const [showDurationTypeBrowser,setShowDurationTypeBrowser] = useState(false);
    const [selectedAvailableSubscriptionsIds,setSelectedAvailableSubscriptionsIds] = useState([]);
    const [availableSubscriptions,setAvailableSubscriptions] = useState(null);
    const [loadingAvailableSubscriptions,setLoadingAvailableSubscriptions] = useState(false);
    const [invoiceOperationStatus,setInvoiceOperationStatus] = useState('');
    const [invoicePayment,setInvoicePayment] = useState(null);

    const [customerName,setCustomerName] = useState('');
    const [customerKRAPIN,setCustomerKRAPIN] = useState('');
    const [selectedCustomerAccount,setSelectedCustomerAccount] = useState(null);
    const [startDate,setStartDate] = useState(null);
    const [selectedDurationType,setSelectedDurationType] = useState(null);
    const [autogenerateInvoice,setAutogenerateInvoice] = useState(false);
    const [notesEntries,setNotesEntries] = useState([]);
    const [subscriptionsEntries,setSubscriptionsEntries] = useState([]);

    const [billingAccounts,setBillingAccounts] = useState(null);
    const durationTypes = [
        {value: 'DAILY',display:'Daily'},
        {value: 'WEEKLY',display: 'Weekly'},
        {value: 'MONTHLY',display: 'Monthly'},
        {value: 'QUARTERLY',display: 'Quarterly'},
        {value: 'SEMI_ANNUAL',display: 'Semi Annually'},
        {value: 'ANNUAL', display: 'Annually'},
        {value: 'PERPETUAL',display: 'Perpetual'}
    ];
    const fetchBillingAccounts = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/accounts`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok) setBillingAccounts(await response.json());
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when processing the request: ${error}`)
        }
    };
    const fetchAvailableSubscriptions = async() =>{
        try{
            console.log('Fetching available subscriptions');
            setLoadingAvailableSubscriptions(true);
            const url = `${billingMicroserviceUrl}/tenants/subscriptions/postpaid?invoiced=false&&durationType=${selectedDurationType?.value}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok) setAvailableSubscriptions([...(selectedInvoice?.devicesSubscriptions || []),...(await response.json() || [])]);
        }
        catch(error){
            console.error('An error occurred when fetching available subscriptions:',error);
        }
        setLoadingAvailableSubscriptions(false);
    };
    const updateInvoice = async() =>{
        try{
            const updateInvoicePayload = {
                customerName:customerName,
                customerKRAPIN:customerKRAPIN,
                customerAccountId:selectedCustomerAccount?.accountId,
                startDateTime: startDate? startDate.toISOString().slice(0,-1):null,
                durationType: selectedDurationType?.value,
                autogenerate:autogenerateInvoice,
                notes:notesEntries && notesEntries?.map((noteEntry) => (noteEntry?.value)),
                devicesSubscriptionsIds:subscriptionsEntries && subscriptionsEntries?.reduce((acc,subscriptionEntry,index) => {acc[index] =subscriptionEntry?.value?.subscriptionId;return acc;},{})
            };
            const url = `${billingMicroserviceUrl}/tenants/invoices/${selectedInvoice?.id}`;
            const response = await fetch(url,{
                method:'PUT',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(updateInvoicePayload)
            });
            if(response.ok){
                const updatedInvoice = await response.json();
                setSelectedInvoice(updatedInvoice);
            }
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`status code: ${response?.status}`);
        }
        catch(error){
            console.error('Unexpected error occurred when updating invoice',error);
        }
    }
    const deleteInvoice = async() =>{
        try{
            setInvoiceOperationStatus('deleting');
            const url = `${billingMicroserviceUrl}/tenants/invoices/${selectedInvoice?.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setInvoiceOperationStatus('deleted');
                setReloadInvoices(true);
                return;
            }
        }
        catch(error){
            console.error('An error occurred when deleting invoice',error);
        }
        setInvoiceOperationStatus('delete-error');
    };
    const issueInvoice = async() =>{
        try{
            setInvoiceOperationStatus('issuing');
            const url = `${billingMicroserviceUrl}/tenants/invoices/issued/${selectedInvoice?.id}`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setSelectedInvoice(await response.json());
                setInvoiceOperationStatus('issued');
                setReloadInvoices(true);
                return;
            }
        }
        catch(error){
            console.error('An error occurred when issuing invoice',error);
        }
        setInvoiceOperationStatus('issue-error');
    };
    const cancelInvoice = async() =>{
        try{
            setInvoiceOperationStatus('cancelling');
            const url = `${billingMicroserviceUrl}/tenants/invoices/created/${selectedInvoice?.id}`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setSelectedInvoice(await response.json());
                setInvoiceOperationStatus('cancelled');
                setReloadInvoices(true);
                return;
            }
        }
        catch(error){
            console.error('An error occurred when cancelling invoice',error);
        }
        setInvoiceOperationStatus('cancel-error');
    };
    const processInvoicePayment = async() =>{
        setInvoiceOperationStatus('processing-payment');
        try{
            const url = `${billingMicroserviceUrl}/tenants/invoices/${selectedInvoice?.id}/payments`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setInvoicePayment(await response.json());
                setInvoiceOperationStatus('payment-processed');
                return;
            }
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when processing invoice payment',error);
        }
        setInvoiceOperationStatus('payment-processing-error');
    };
    const reversePayment = async() =>{
        setInvoiceOperationStatus('reversing-payment');
        try{
            setInvoiceOperationStatus('payment-reversed');
            return;
        }
        catch(error){
            console.error('An error occurred when reversing invoice payment',error);
        }
        setInvoiceOperationStatus('payment-reverse-error');
    };
    const formValidToolTip = () =>{
        if(customerName === '') return 'Enter the customer name to proceed';
        else if(selectedCustomerAccount === null) return 'Select the customer acccount to bill to proceed';
        else if(startDate === null) return 'Select the invoice start date to proceed';
        else if(selectedDurationType === null) return 'Select the invoice duration type to proceed';
        else if(!subscriptionsEntries || subscriptionsEntries.length === 0) return 'Add at least one subscription entry to proceed';
        else if(notesEntries && notesEntries?.some((entry) => (entry?.value === null || entry?.value === ''))) return 'Each note entry must have a value';
        else if(subscriptionsEntries && subscriptionsEntries?.some((entry) => (entry.value === null))) return 'Each subscription entry must have a valid post paid device subscription';
        return '';
    };
    const convertToReactDate = (date,time) =>{
        if(!date || !time) return '';
        const [day,month,year] = date.split('-').map(Number);
        const [hours,minutes,seconds] = time.split(':').map(Number);
        return new Date(year,month - 1,day,hours,minutes,seconds);
    };
    useEffect(() =>{
        if(!selectedInvoice) return;
        fetchBillingAccounts();
        setCustomerName(selectedInvoice?.customerName || '');
        setCustomerKRAPIN(selectedInvoice?.customerKRAPIN || '');
        setStartDate(convertToReactDate(selectedInvoice?.startDate,selectedInvoice?.startTime));
        setSelectedDurationType(durationTypes.find(durationType => durationType.value === selectedInvoice?.durationType));
        setAutogenerateInvoice(selectedInvoice?.autogenerate);
        setNotesEntries(selectedInvoice?.notes.map(note => ({id: uuidv4(),value:note})));
        setSubscriptionsEntries(selectedInvoice?.devicesSubscriptions?.map((deviceSubscription) =>({
            id:uuidv4(),
            filterString:'',
            value:deviceSubscription,
            showBrowser:false
        })) || []);
    },[selectedInvoice]);
    useEffect(() =>{
        if(!selectedInvoice?.customerAccountNumber || !Array.isArray(billingAccounts) || billingAccounts.length === 0) return;
        setSelectedCustomerAccount(billingAccounts.find(account => account?.accountNumber === selectedInvoice?.customerAccountNumber));
    },[selectedInvoice,billingAccounts]);
    useEffect(() => {
        console.log('Billing accounts',billingAccounts);
    },[billingAccounts]);
    useEffect(() =>{
        setSelectedAvailableSubscriptionsIds((subscriptionsEntries || []).map((subscriptionEntry) => (subscriptionEntry?.value?.subscriptionId)));
    },[subscriptionsEntries]);
    useEffect(() =>{
        if(selectedInvoiceDetailsTab === 'subscriptions') fetchAvailableSubscriptions();
    },[selectedInvoiceDetailsTab]);
    useEffect(()=> {
        console.log('Current invoice operation status',invoiceOperationStatus);
        
    },[invoiceOperationStatus]);
    return(
        <div className={`tenant-administrator-invoice-details-parent-container ${selectedInvoiceTab === 'default'? 'default':selectedInvoiceTab === 'details'? 'active':'inactive'}`}>
            {invoiceOperationStatus === 'issuing'?
                (
                    <div className="tenant-administrator-invoice-details-issuing-invoice-container">
                        <div></div>
                        <p>Issuing invoice. Please wait...</p>
                    </div>
                ):invoiceOperationStatus === 'issued'?
                (
                    <div className="tenant-administrator-invoice-details-invoice-issued-container">
                        <p>Invoice {selectedInvoice?.invoiceNumber} issued successfully</p>
                        <div>
                            <button onClick={() => setInvoiceOperationStatus('')}>Okay</button>
                        </div>
                    </div>
                ):invoiceOperationStatus === 'deleting'?
                (
                    <div className="tenant-administrator-invoice-details-deleting-invoice-container">
                        <div></div>
                        <p>Deleting invoice. Please wait...</p>
                    </div>
                ):invoiceOperationStatus === 'deleted'?
                (
                    <div className="tenant-administrator-invoice-details-invoice-deleted-container">
                        <p>Invoice {selectedInvoice?.invoiceNumber} deleted successfully</p>
                        <div>
                            <button onClick={() =>setInvoiceOperationStatus('')}>Okay</button>
                        </div>
                    </div>
                ):invoiceOperationStatus === 'cancelling'?
                (
                    <div className="tenant-administrator-invoice-details-cancelling-invoice-container">
                        <div>
                        </div>
                        <p>Cancelling invoice. Please wait...</p>
                    </div>
                ):invoiceOperationStatus === 'cancelled'?
                (
                    <div className="tenant-administrator-invoice-details-invoice-cancelled-container">
                        <p>Invoice {selectedInvoice?.invoiceNumber} cancelled successfully</p>
                        <div>
                            <button onClick={() => setInvoiceOperationStatus('')}>Okay</button>
                        </div>
                    </div>
                ):invoiceOperationStatus === 'confirming-invoice-payment'?
                (() =>{
                    const billingAccount = billingAccounts?.find(billingAccount => billingAccount?.accountNumber === selectedInvoice?.customerAccountNumber);
                    console.log('Billing account',billingAccount);
                    return(
                        <div>
                            {billingAccount?.balance == null?
                                (
                                    <div className="tenant-administrator-invoice-details-invoice-payment-loading-account-container">
                                        <div>
                                        </div>
                                        <p>Loading linked customer's account. Please wait...</p>
                                    </div>
                                ):billingAccount?.balance < selectedInvoice?.totalPrice?
                                (
                                    <div className="tenant-administrator-invoice-details-invoice-payment-insufficient-funds-container">
                                        <p>The customer's account linked to this invoice has insufficient funds.</p>
                                        <p>Please top up the account and try again.</p>
                                        <div>
                                            <button onClick={() => setInvoiceOperationStatus('')}>Okay</button>
                                            <button onClick={() => navigate('/tenants/billing-accounts')}>Top up</button>
                                        </div>
                                    </div>
                                ):
                                (
                                    <div className="tenant-administrator-invoice-details-invoice-payment-confirmation-container">
                                        <div className="details-parent-container">
                                            <p>Process invoice payment?</p>
                                            <div className="details-container">
                                                <strong>Invoice Number</strong>
                                                <span>{selectedInvoice?.invoiceNumber}</span>
                                                <strong>Customer Name</strong>
                                                <span>{selectedInvoice?.customerName}</span>
                                                <strong>Billing Account</strong>
                                                <span>{billingAccount?.accountNumber}</span>
                                                <strong>Subtotal Due</strong>
                                                <span>{Number(selectedInvoice?.price).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                                                <strong>Tax Due</strong>
                                                <span>{Number(selectedInvoice?.tax).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                                                <strong className="total">Total Due</strong>
                                                <span className="total">KES {Number(selectedInvoice?.totalPrice).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                                                <strong className="available-balance">Available Balance</strong>
                                                <span className="available-balance">KES {Number(billingAccount?.balance).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                                                <strong className="remaining-balance">Remaining Balance</strong>
                                                <span className="remaining-balance">KES {(Number(billingAccount?.balance) - Number(selectedInvoice?.totalPrice)).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                                            </div>
                                            <div className="buttons-container">
                                                <button onClick={() => setInvoiceOperationStatus('')}>Back</button>
                                                <button title="Process invoice payment" onClick={() => processInvoicePayment()}>Proceed</button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    );
                })():invoiceOperationStatus === 'processing-payment'?
                (
                    <div className="tenant-administrator-invoice-details-processing-invoice-payment-container">
                        <div>
                        </div>
                        <p>Processing payment. Please wait...</p>
                    </div>
                ):invoiceOperationStatus === 'payment-processed'?
                (
                    <div className="tenant-administrator-invoice-details-invoice-payment-processed-container">
                        <p>Invoice {selectedInvoice?.invoiceNumber} payment processed successfully</p>
                        <div>
                            <button onClick={() => reversePayment()}>Reverse</button>
                            <button onClick={() => setInvoiceOperationStatus('')}>Okay</button>
                        </div>
                    </div>
                ):invoiceOperationStatus === 'payment-processing-error'?
                (
                    <div className="tenant-administrator-invoice-details-invoice-payment-processing-error-container">
                        <p>An error occurred when processing payment for invoice "{selectedInvoice?.invoiceNumber}"</p>
                        <div>
                            <button onClick={() => setInvoiceOperationStatus('')}>Okay</button>
                        </div>
                    </div>
                ):invoiceOperationStatus === 'reversing-payment'?
                (
                    <div className="tenant-administrator-invoice-details-invoice-payment-reversing-container">
                        <div>
                        </div>
                        <p>Reversing payment. Please wait...</p>
                    </div>
                ):invoiceOperationStatus === 'payment-reversed'?
                (
                    <div className="tenant-administrator-invoice-details-invoice-payment-reversed-container">
                        <p>Payment reversed successfully</p>
                        <div>
                            <button onClick={() => setInvoiceOperationStatus('')}>Okay</button>
                        </div>
                    </div>
                ):
                invoiceOperationStatus === 'payment-reverse-error'?
                (
                    <div className="tenant-administrator-invoice-details-invoice-payment-reverse-error-container">
                        <p>An error occurred when reversing payment</p>
                        <div>
                            <button onClick={() => setInvoiceOperationStatus('')}>Okay</button>
                        </div>
                    </div>
                ):
                (
                    <div>
                        <div className="tenant-administrator-invoice-details-parent-navigation-bar">
                            <div>
                                {selectedInvoice?.status === 'CREATED'?
                                    (
                                        <>
                                            <button
                                                onClick={async() =>{
                                                    if(invoiceEditMode){
                                                        await updateInvoice();
                                                        window.alert('Invoice updated successfully');
                                                        setInvoiceEditMode(false);
                                                    }
                                                    else setInvoiceEditMode(true);
                                                }}
                                            >{invoiceEditMode? 'Update invoice':'Edit invoice'}
                                            </button>
                                            <button
                                                style={{display:invoiceEditMode? 'none':'inline-block'}}
                                                onClick={() => issueInvoice()}>Issue invoice
                                            </button>
                                            <button onClick={() => deleteInvoice()}>Delete invoice</button>
                                        </>
                                    ):selectedInvoice?.status === 'ISSUED'?
                                    (
                                        <>
                                            <button onClick={() => cancelInvoice()}>Cancel invoice</button>
                                            <button onClick={() => setInvoiceOperationStatus('confirming-invoice-payment')}>Process payment</button>
                                        </>
                                    ):selectedInvoice?.status === 'PAID'?
                                    (
                                        <>
                                            <p style={{margin:'0px',color:'green',cursor:'default'}}>Invoice Paid</p>
                                        </>
                                    ):
                                    (
                                        <></>
                                    )
                                }
                            </div>
                        </div>
                        <div className="tenant-administrator-invoice-details-container">
                            <div className={`tenant-administrator-invoice-details-edit-mask-container ${invoiceEditMode? 'hidden':''}`}></div>
                            <div className="tenant-administrator-invoice-details-navigation-bar">
                                <button className={selectedInvoiceDetailsTab === 'primary-details' || selectedInvoiceDetailsTab === 'default'? 'active':''}
                                    onClick={() => setSelectedInvoiceDetailsTab('primary-details')}>Primary details</button>
                                <button className={selectedInvoiceDetailsTab === 'subscriptions'? 'active':''}
                                    onClick={() => setSelectedInvoiceDetailsTab('subscriptions')}>Subscriptions</button>
                            </div>
                            <div className={`tenant-administrator-invoice-details-primary-details-container ${selectedInvoiceDetailsTab === 'default'? 'default':selectedInvoiceDetailsTab === 'primary-details'? 'active':'inactive'}`}>
                                <div className="tenant-administrator-invoice-details-entry-container">
                                    <p>Invoice Number</p>
                                    <input readOnly value={selectedInvoice?.invoiceNumber || ''}/>
                                </div>
                                <div className="tenant-administrator-invoice-details-entry-container">
                                    <p>Customer name<span>*</span></p>
                                    <input
                                        value={customerName}
                                        onChange={(e) => setCustomerName(e.target.value)}
                                    />
                                </div>
                                <div className="tenant-administrator-invoice-details-entry-container">
                                    <p>Customer KRA PIN</p>
                                    <input
                                        value={customerKRAPIN}
                                        onChange={(e) => setCustomerKRAPIN(e.target.value)}
                                    />
                                </div>
                                <div className="tenant-administrator-invoice-details-entry-container">
                                    <p>Customer Account<span>*</span></p>
                                    {selectedCustomerAccount?
                                        (
                                            <div className="tenant-administrator-invoice-details-selected-customer-account-container">
                                                <p>{selectedCustomerAccount?.accountNumber}</p>
                                                <p>
                                                    {selectedCustomerAccount?.userEmailAddress}
                                                    <span
                                                        title="Remove selection"
                                                        onClick={() => setSelectedCustomerAccount(null)}>&#10006;
                                                    </span>
                                                </p>
                                            </div>
                                        ):
                                        (
                                            <input
                                                placeholder="Enter customer account number or email address"
                                                value={customerAccountFilterString}
                                                onChange={(e) => setCustomerAccountFilterString(e.target.value)}
                                                onFocus={() => setShowCustomerAccountBrowser(true)}
                                                onBlur={() =>{
                                                    setTimeout(() =>{setShowCustomerAccountBrowser(false)},150);
                                                }}
                                            />
                                        )
                                    }
                                    <div className={`tenant-administrator-invoice-details-customer-account-browser ${showCustomerAccountBrowser? 'active':''}`}>
                                        {billingAccounts && [...billingAccounts].filter((billingAccount) =>(
                                            billingAccount?.accountNumber?.includes(customerAccountFilterString) || billingAccount?.userEmailAddress?.includes(customerAccountFilterString)
                                        )).sort((a,b) => (a?.userEmailAddress || '').localeCompare(b?.userEmailAddress || ''))
                                        .map((billingAccount) =>(
                                            <div key={billingAccount?.accountId} onClick={() =>{
                                                setCustomerAccountFilterString('');
                                                setSelectedCustomerAccount(billingAccount);
                                            }}>
                                                <p>{billingAccount?.accountNumber}</p>
                                                <p>{billingAccount?.userEmailAddress}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="tenant-administrator-invoice-details-entry-container">
                                    <p>Start Date<span>*</span></p>
                                    <DatePicker
                                        placeholderText="Select start date and time"
                                        selected={startDate}
                                        onChange={(e) => setStartDate(e)}
                                        minDate={Date.now()}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                        dateFormat={"dd/MM/yyyy HH:mm"}
                                        popperPlacement="bottom-end"
                                    />
                                </div>
                                <div className="tenant-administrator-invoice-details-entry-container">
                                    <p>Duration Type<span>*</span></p>
                                    {selectedDurationType?
                                        (
                                            <div className="tenant-administrator-invoice-details-selected-duration-type-container">
                                                <p>{selectedDurationType?.display}</p>
                                                <p className="cancel-p" onClick={() => setSelectedDurationType(null)}>&#10006;</p>
                                            </div>
                                        ):
                                        (
                                            <input
                                                placeholder="Enter duration type"
                                                value={durationTypeFilterString}
                                                onChange={(e) => setDurationTypeFilterString(e.target.value)}
                                                onFocus={() => setShowDurationTypeBrowser(true)}
                                                onBlur={() =>{
                                                    setTimeout(() => {setShowDurationTypeBrowser(false)},150)
                                                }}
                                            />
                                        )
                                    }
                                    <div className={`tenant-administrator-invoice-details-duration-type-browser ${showDurationTypeBrowser? 'active':''}`}>
                                        {durationTypes?.filter((durationType) => durationType?.display?.toLowerCase()?.includes(durationTypeFilterString.toLowerCase()))
                                        .map((durationType) => (
                                            <div key={durationType?.value} onClick={() =>{
                                                setDurationTypeFilterString('');
                                                setSelectedDurationType(durationType);
                                            }}>{durationType?.display}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="tenant-administrator-invoice-details-autogenerate-container">
                                    <ToogleButton
                                        size="40px"
                                        marginRight="10px"
                                        isToogled={autogenerateInvoice}
                                        onChange={() => setAutogenerateInvoice(!autogenerateInvoice)}
                                    />
                                    <p>Auto generate {selectedDurationType?.display?.toLowerCase()}</p>
                                </div>
                                <div className="tenant-administrator-invoice-details-notes-container">
                                    <div className="tenant-administrator-invoice-details-notes-header">
                                        <h3>Notes</h3>
                                        <p title="Add a note" onClick={() => setNotesEntries([...notesEntries,{id: uuidv4(), value: ""}])}>+</p>
                                    </div>
                                    <div className="tenant-administrator-invoice-details-notes-body">
                                        {notesEntries.map((noteEntry,index) =>(
                                            <div className={noteEntry?.value.length === 0? 'empty':''} key={noteEntry?.id}>
                                                <p>{index + 1}.</p>
                                                <input
                                                    value={noteEntry?.value}
                                                    onChange={(e) => setNotesEntries(prev => prev.map(
                                                        (entry) => entry.id === noteEntry?.id? {...entry,value:e.target.value}:entry
                                                    ))}
                                                />
                                                <img
                                                    title="Delete entry"
                                                    onClick={() =>{
                                                        setNotesEntries(prev => (prev.filter(entry => entry?.id !== noteEntry?.id)))
                                                    }}
                                                    src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className={`tenant-administrator-invoice-details-subscriptions-container ${selectedInvoiceDetailsTab === 'default'? 'default':selectedInvoiceDetailsTab === 'subscriptions'? 'active':'inactive'}`}>

                                <div className="tenant-administrator-invoice-details-subscriptions-header">
                                    <h3>Subscriptions</h3>
                                    <p
                                        title="Add a subscription"
                                        style={{display:loadingAvailableSubscriptions || !selectedDurationType? 'none':'block'}}
                                        onClick={() => setSubscriptionsEntries([...subscriptionsEntries,{id:Date.now(),filterString:'',value:null,showBrowser:false}])}>+
                                    </p>
                                </div>
                                <div className="tenant-administrator-invoice-details-subscriptions-body">
                                    {!selectedDurationType?
                                        (
                                            <div className="tenant-administrator-invoice-details-subscriptions-no-duration-type-parent-container">
                                                <div className="tenant-administrator-invoice-details-subscriptions-no-duration-type-container">
                                                    <h2>No subscriptions available</h2>
                                                    <p>Select a duration type in the Primary details page to proceed.</p>
                                                </div>
                                            </div>
                                        ):loadingAvailableSubscriptions?
                                        (
                                            <div className="tenant-administrator-invoice-details-loading-available-subscriptions-parent-container">
                                                <div className="tenant-administrator-invoice-details-loading-available-subscriptions-container">
                                                    <div></div>
                                                    <p>Loading available subscriptions. Please wait...</p>
                                                </div>
                                            </div>
                                        ):
                                        (
                                            <div className="tenant-administrator-invoice-details-subscription-entries-container">
                                                {subscriptionsEntries && subscriptionsEntries.map((subscriptionsEntry) =>(
                                                    <div className="tenant-administrator-invoice-details-subscription-entry-container">
                                                        <div className="tenant-administrator-invoice-details-subscription-entry-sub-container">
                                                            {subscriptionsEntry?.value?
                                                                (<div className="tenant-administrator-invoice-details-subscription-entry-value-container">
                                                                    <p>{subscriptionsEntry?.value?.deviceName || ''}</p>
                                                                    <div>
                                                                        <p>{subscriptionsEntry?.value?.planName}</p>
                                                                        <p
                                                                            className="remove-p"
                                                                            title="Remove selection"
                                                                            onClick={() =>{
                                                                                setSubscriptionsEntries(prev => prev.map(entry => entry?.id === subscriptionsEntry?.id? {...entry,value:null}:entry));
                                                                            }}>&#10006;</p>
                                                                    </div>
                                                                </div>
                                                                ):
                                                                (
                                                                    <input
                                                                        value={subscriptionsEntry?.filterString}
                                                                        onChange={(e) =>{
                                                                            setSubscriptionsEntries(prev => prev.map(entry => entry?.id === subscriptionsEntry?.id? {...entry,filterString:e.target.value}:entry));
                                                                        }}
                                                                        onFocus={() =>{
                                                                            setSubscriptionsEntries(prev => prev.map(entry => entry?.id === subscriptionsEntry?.id? {...entry,showBrowser:true}:entry));
                                                                        }}
                                                                        onBlur={() =>{
                                                                            setTimeout(() =>{
                                                                                setSubscriptionsEntries(prev => prev.map(entry => entry?.id === subscriptionsEntry?.id? {...entry,showBrowser:false}:entry));
                                                                            },150);
                                                                        }}
                                                                    />
                                                                )
                                                            }
                                                            <div className={`tenant-administrator-invoice-details-subscriptions-browser ${subscriptionsEntry?.showBrowser? 'active':''}`}>
                                                                {availableSubscriptions && [...availableSubscriptions]
                                                                    .filter(availableSubscription => !selectedAvailableSubscriptionsIds?.includes(availableSubscription?.subscriptionId))
                                                                    .filter(availableSubscription => (
                                                                        (availableSubscription?.deviceName?.toLowerCase().includes(subscriptionsEntry?.filterString?.toLowerCase()) ||
                                                                        (availableSubscription?.planName?.toLowerCase().includes(subscriptionsEntry?.filterString?.toLowerCase()))
                                                                    ))).map((availableSubscription) =>(
                                                                    <div key={availableSubscription?.subscriptionId}
                                                                        onClick={() =>{
                                                                            setSubscriptionsEntries(prev => prev.map((entry) => entry?.id === subscriptionsEntry?.id? {...entry,value:availableSubscription}:entry));
                                                                        }}>
                                                                        <p>{availableSubscription?.deviceName}</p>
                                                                        <p>{availableSubscription?.planName}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <img
                                                            title="Delete entry"
                                                            onClick={() => setSubscriptionsEntries(prev => prev.filter(entry => entry?.id !== subscriptionsEntry?.id))}
                                                            src={`${process.env.PUBLIC_URL}/images/trash-can-icon.png`}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default InvoiceDetails;